module.exports = __webpack_public_path__ + "img/thumbnail_EurasianLynx_j_albino.f354e9cb.png";